import axios from "axios";
import api from "..";
import type {
  IIllegalParkingReportResponse,
  IParkingBeesEvChargerVacancyResponse,
} from "./type";

const API_URL =
  process.env.REACT_APP_ENV === "prod"
    ? "https://api.parkingbees.com.hk/email/send-general-email"
    : "http://localhost:3000/email/send-general-email";

const ASGARD_RECIPIENT =
  process.env.REACT_APP_ENV === "prod"
    ? ["hello@asgardev.com.hk"]
    : ["edison@wasphk.com"];

export const sendUserFeedback = async (
  name: string,
  email: string,
  phone: string,
  message: string
) => {
  const response = await axios.post<{ statusCode: number }>(`${API_URL}`, {
    sender: "no-reply@asgardev.com.hk",
    recipient: ASGARD_RECIPIENT, //TODO: update email
    subject: "Asgard EV - 用戶意見反映／查詢",
    body: `
    <p>姓名: ${name}</p>
    <p>電郵: ${email}</p>
    <p>電話: ${phone}</p>
    <p>意見/查詢內容: ${message}</p>`,
  });

  return response.data;
};

export const getEVInfo = async (ms_token?: string) => {
  const response = await api.post<IParkingBeesEvChargerVacancyResponse[]>(
    `/ev_charger_session_record/get-ev-charger-vacancy-and-estimate-availability-by-token`,
    {
      ms_token: ms_token ? ms_token : undefined,
    }
  );

  return response.data;
};

// prepare

export const getEsovoltVacancy = async (charger_identifiers: string[]) => {
  const response = await api.post<{
    availableCount: string;
    workingConnectors: string;
  }>(`/ev_charger_session_record/getEvVacancy`, {
    charger_identifiers: charger_identifiers,
  });

  return response.data;
};

export const estimateNextChargerAvailability = async (
  charger_identifiers: string[]
) => {
  const response = await api.post<{ estimatedWaitingTime: number } | null>(
    `/ev_charger_session_record/estimateNextChargerAvailability`,
    {
      charger_identifiers: charger_identifiers,
    }
  );

  return response.data;
};

export const getEVConfig = async () => {
  const response = await api.get<any[]>(
    `/ev_charger_session_record/get-all-supported-ev-config`
  );

  return response.data;
};

export const getExistingConfirmedReports = async () => {
  const response = await api.get<IIllegalParkingReportResponse[]>(
    `/illegal-parking-reports/get-existing-confirmed-reports`
  );

  return response.data;
};

export const createIllegalParkingReport = async (
  parking_id: number,
  plate: string,
  remark: string,
  file: File
) => {
  const response = await api.post<IIllegalParkingReportResponse>(
    `/illegal-parking-reports`,
    {
      parking_id,
      car_plate: plate,
      remark,
      file,
      source: "asgard-ev-app",
    },
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  );

  return response.data;
};
